import { OptionSelect } from '@/core/utils/types'
import { useMemo } from 'react'
import { DEPARTAMENTO_QUERY } from '../data/departamento'
import { DepartamentoQueryQuery } from '@/core/types/graphql'
import { useQuery } from '@tanstack/react-query'
import { request } from '../../../core/utils/request'

export const useDepartamentos = () => {
  const { data: { departamentos = [] } = {}, isLoading } =
    useQuery<DepartamentoQueryQuery>({
      queryKey: ['departamentos'],
      queryFn: async () => await request(DEPARTAMENTO_QUERY)
    })

  const departamentosOptions = useMemo(
    () =>
      departamentos?.map(it => ({
        label: it?.nome,
        value: it?.id
      })) as OptionSelect[],
    [departamentos]
  )

  return {
    DepartamentosOptions: departamentosOptions,
    loadingDepartamentos: isLoading
  }
}
